import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // still checking session
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center bg-background"
      >
        <div className="flex flex-col items-center gap-4">
          <div className="animate-pulse-soft">
            <Logo size={56} />
          </div>
          <p className="text-sm text-muted-foreground">
            Vérification de la session…
          </p>
        </div>
      </div>
    );
  }

  if (user === false) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );
  }

  return children;
}
